module.exports = __webpack_public_path__ + "static/img/3.23fe26a.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/yinyuedeng/3.jpg
// module id = pAPZ
// module chunks = 1